import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { ImageCroppedEvent, ImageCropperModule } from 'ngx-image-cropper';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-crop-dialog',
  templateUrl: './crop-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, ImageCropperModule],
})
export class CropDialogComponent {
  dialogTitle: string;
  action: string;
  imageChangedEvent: string = '';
  croppedImage = '';
  croppedImageFile: File | null | undefined;
  showCrop = true;
  aspectRatio;
  resizeToWidth: number;
  invalidImg = true;
  verifying = true;

  constructor(
    private dialogRef: MatDialogRef<CropDialogComponent>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.dialogTitle = data.dialogTitle;
    this.aspectRatio = data.aspectRatio ? data.aspectRatio : 1 / 1;
    this.resizeToWidth = data.resizeToWidth ? data.resizeToWidth : 0;
    this.action = data.action;
    this.imageChangedEvent = data.event;
    const reader = new FileReader();
    if (data.event && data.event.target && data.event.target.files.lenght > 0) {
      reader.readAsDataURL(data.event.target.files[0]);
    }
    reader.onload = () => {
      const tmpIndex = String(reader.result).indexOf(',');
      String(reader.result).replace(
        String(reader.result).substring(0, tmpIndex + 1),
        ''
      );
    };
  }

  save(): void {
    this.dialogRef.close({
      img: this.croppedImageFile,
      imgView: this.croppedImage,
    });
  }
  close(): void {
    this.dialogRef.close();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.showCrop = true;
  }
  imageCropped(event: ImageCroppedEvent): void {
    this.croppedImage = event.objectUrl ? event.objectUrl : '';
    if (event.blob) {
      this.croppedImageFile = new File(
        [event.blob],
        Date.now().toString() + '.webp',
        { type: 'image/webp' }
      );
    }
  }
}
